import { render, staticRenderFns } from "./academy_client_profile.vue?vue&type=template&id=1b2231b0&"
import script from "./academy_client_profile.vue?vue&type=script&lang=js&"
export * from "./academy_client_profile.vue?vue&type=script&lang=js&"
import style0 from "./academy_client_profile.vue?vue&type=style&index=0&id=1b2231b0&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionClientProfile: require('/home/smiley/3df/components/Section/SectionClientProfile/SectionClientProfile.vue').default,CardBig: require('/home/smiley/3df/components/Card/CardBig/CardBig.vue').default})
